export const isClosedWorkflowStatus = (status) =>
  ["closed", "gesloten"].includes(String(status || "").trim().toLowerCase());
